import { useState } from 'react';
import { Button, Confirm, useRecordContext, useNotify, useRefresh } from 'react-admin';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { DEFAULT_API_ADMIN } from '../../constants';
import { httpClientReactAdmin } from '../../lib';

export const MarkVerifiedButton = ({ size = 'small' }: { size?: 'small' | 'medium' | 'large' }) => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!record || record.emailVerified) return null;

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await httpClientReactAdmin(
        `${DEFAULT_API_ADMIN}/employees/${record.id}`,
        { method: 'PATCH', body: JSON.stringify({ emailVerified: true }) },
      );
      notify('Conta marcada como verificada!', { type: 'success' });
      refresh();
    } catch (err: any) {
      const message = err?.body?.message || err?.message || 'Erro ao verificar conta';
      notify(message, { type: 'error' });
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <>
      <Button
        label="Marcar como verificado"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        disabled={loading}
        startIcon={<VerifiedUserIcon />}
        variant="outlined"
        size={size}
        sx={{ ml: 2 }}
      />
      <Confirm
        isOpen={open}
        loading={loading}
        title="Marcar como verificado"
        content={`Deseja marcar o email "${record.login}" como verificado? O usuário poderá fazer login sem confirmar o email.`}
        onConfirm={handleConfirm}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
